import { FEATURE_NAME } from "../constants/namespace";

export const agentMatchSelector = state => state[FEATURE_NAME].agentMatch;
export const contactFormSelector = state => state[FEATURE_NAME].contactForm;
export const uiSelector = state => state[FEATURE_NAME].ui;
